import React from 'react';
import  {Badge} from 'react-bootstrap';

class RespondedAmount extends React.Component {
    respondedPhrase = (count) => {
        let string = count.toString()
        let last_letter = string.slice(-1);
        if (string === 1) {
                return 'udzielona porada dla klienta';
            } else if (string === 0) {
                return 'Brak udzielonych porad dla klientów'
            } else if (last_letter >=2 && last_letter <=4 && (string < 12 || string > 14 )) {
                return 'udzielone porady dla klientów';
            } else {
                return 'udzielonych porad dla klientów';
            };
    }
    render() {
        const {responded_count} = this.props;
        if(!responded_count) {
            return null;
        }
        return(
            <div className="top-buffer-mega">
                <h2>
                    <Badge className={`${responded_count ? 'success' : 'danger'}`}>{responded_count}</Badge>
                    {this.respondedPhrase(responded_count)}
                </h2>
            </div>
        )
    }
}

export default RespondedAmount;